export default "__VITE_PUBLIC_ASSET__01a97500__"